const DEFAULT_TIMEOUT = 8;

export const stateObj = {
  current: null,
};

const getters = {};

const actions = {
  setMessage({commit, dispatch}, payload) {
    commit('SET_MESSAGE', payload);

    // set timeout to -1 if you want it to never disappear
    if (payload.timeout === -1) {
      return;
    }

    // if timeout is provided use the value
    if (Number.isInteger(payload.timeout)) {
      setTimeout(() => {
        dispatch('clearMessage');
      }, 1000 * payload.timeout);

      return;
    }

    // unspecified, use default
    setTimeout(() => {
      dispatch('clearMessage');
    }, 1000 * DEFAULT_TIMEOUT);
  },

  clearMessage({commit}) {
    commit('CLEAR_MESSAGE');
  },
};

const mutations = {
  SET_MESSAGE(state, message) {
    state.current = message;
  },

  CLEAR_MESSAGE(state) {
    state.current = null;
  },
};

export default {
  namespaced: true,
  state: stateObj,
  getters,
  actions,
  mutations,
};
